import { fetchSinToken, fetchConToken , calculateRemainingTime} from '../helpers/fetch';
//import { types } from '../types/types';
import Swal from 'sweetalert2';
//import { useHistory } from 'react-router-dom';
import { authActions } from './auth-slice';
import { dataActions } from './data-slice';


let logoutTimer;



const retrieveStoredToken = () => {
    const storedToken = sessionStorage.getItem('token');
    const storedExpirationDate = sessionStorage.getItem('expirationTime');
    const username = sessionStorage.getItem('username');
  
    const remainingTime = calculateRemainingTime(storedExpirationDate);
    

    console.log("remaining time in auth-actions retrieve token", remainingTime )
    if (remainingTime <= 3000) {
        sessionStorage.clear();
      return null;
    }
  
    return {
      token: storedToken,
      duration: storedExpirationDate,
      name: username,
    };
};


export const startLogout = () => {
    return ( dispatch ) => {
        console.log("startLogout:");
        if (logoutTimer) {
            console.log("clear logout timer");
            clearTimeout(logoutTimer);
        }
        sessionStorage.clear();
        dispatch( authActions.logout() );
       
    }
}

function myGreeting() {
    alert("Happy Birthday");
}

export const startLogin = ( email, password ) => {
    return async( dispatch ) => {
        try {
            console.log("startLogin:");

            const resp = await fetchSinToken( 'auth/', { email, password }, 'POST' );
            const body = await resp.json();
    
            if( body.ok ) {

                const expirationTime = new Date(new Date().getTime() + body.tokenExpiresIn*1000 );
                sessionStorage.setItem('token', body.token );
                sessionStorage.setItem('expirationTime', expirationTime.toISOString() );
                sessionStorage.setItem('username', body.name );

              /*   const remainingTime = calculateRemainingTime(expirationTime.toISOString());
                logoutTimer = setTimeout(myGreeting, 10000)
                console.log("start timer logout:", remainingTime ) */
                
                //const myTimeout = setTimeout(myGreeting, 5000);

                dispatch( authActions.login({
                    checking: true,
                    token: body.token,
                    tokenExpiresIn: expirationTime.toISOString(),
                    isLoggedin: true,
                    name: body.name
                }) )

                

                dispatch( dataActions.dataPlantaciones({
                    plantaciones: body.plantaciones,
                    
                }) )
                //console.log("plantaciones en startLogin:" + body.plantaciones[0].nombre);
                
            } else {
                Swal.fire('Error Login', body.msg, 'error');
                sessionStorage.clear();
                dispatch( authActions.logout() );
            }
            
        } catch (error) {
            console.log(error);
            Swal.fire('Error - Code:0x002', "Problema de Conexión con la aplicación. ", 'error');
            
        }
        dispatch( authActions.checkingFinish() );
       
        

    }
}



export const startChecking = () => {
    //const history = useHistory();
    

    return async(dispatch) => {

        try {

            console.log("startChecking:");

            const tokenData = retrieveStoredToken();


            let token;
            if (tokenData) {
                token = tokenData.token;
                console.log(tokenData.duration);
                
                const resp = await fetchConToken( 'auth/renew' );
                const body = await resp.json();

                if( body.ok ) {
                    /* dispatch( authActions.login({
                        checking: true,
                        token: body.token,
                        isLoggedin: true,
                        name: body.name
                    }) ) */

                    dispatch( authActions.login({
                        checking: true,
                        token: token,
                        isLoggedin: true,
                        name: tokenData.name,
                        tokenExpiresIn: tokenData.duration,
                    }) )

                    

                    dispatch( dataActions.dataPlantaciones({
                        plantaciones: body.plantaciones,
                        
                    }) )
                } else {
                    Swal.fire('Tiempo maximo de session', "Haga login nuevamente", 'error');
                    //history.replace('/login');  //redirect to login if invalid token
                    localStorage.clear();
                    dispatch( authActions.logout() );
                    
                }


                


                //logoutTimer = setTimeout(startLogout, tokenData.duration);
            }


            /* 
            if (token != null){
                const resp = await fetchConToken( 'auth/renew' );
                const body = await resp.json();
                if( body.ok ) {
                    localStorage.setItem('token', body.token );
                    localStorage.setItem('token-init-date', new Date().getTime() );

                    dispatch( authActions.login({
                        checking: true,
                        token: body.token,
                        isLoggedin: true,
                        name: body.name
                    }) )

                    

                    dispatch( dataActions.dataPlantaciones({
                        plantaciones: body.plantaciones,
                        
                    }) )
                } else {
                    Swal.fire('Tiempo maximo de session', "Haga login nuevamente", 'error');
                    //history.replace('/login');  //redirect to login if invalid token
                    localStorage.clear();
                    dispatch( authActions.logout() );
                    
                }
            }
            //localStorage.clear();
            //dispatch( logout() ); */
            
        } catch (error) {
            console.log(error);
            Swal.fire('Error', "Conexión con servidor. Notifique al adminsitrador", 'error');
            
            
        }
        dispatch( authActions.checkingFinish() );
    }
}

export const startRegister = ( email, password, name ) => {
    return async( dispatch ) => {
        try {
            const resp = await fetchSinToken( 'auth/new', { email, password, name }, 'POST' );
            const body = await resp.json();

            if( body.ok ) {
                sessionStorage.setItem('token', body.token );
                sessionStorage.setItem('token-init-date', new Date().getTime() );

                dispatch( authActions.login({
                    uid: body.uid,
                    name: body.name,
                    token: body.token,
                }) )
                
                
                dispatch( dataActions.dataPlantaciones({
                    plantaciones: body.plantaciones,

                }) )

            } else {
                Swal.fire('Error', body.msg, 'error');
                sessionStorage.clear();
                dispatch( authActions.logout() );
            }
        } catch (error) {
            console.log(error);
            Swal.fire('Error', "Conexión con la aplicación. Notifique al adminsitrador", 'error');
            
        }
        


    }
}









